import { useRef } from 'react';
import { useIntl } from 'react-intl';
import { useButton } from 'react-aria';
import useAuth from 'client/utils/auth/useAuth';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from '../SignInOut.module.scss';

const SignIn = (props) => {
    const intl = useIntl();
    const ref = useRef();

    const { signIn } = useAuth();

    const { buttonProps } = useButton({
        ...props,
        elementType: 'a',
        onPress: signIn
    }, ref);

    return (
        <>
            <li
                data-testid="navbar.link.signin"
                className="govuk-header__navigation-item"
                role="none"
            >
                <a
                    ref={ref}
                    {...buttonProps}
                    className={[styles.pointer, 'govuk-header__link'].join(' ')}
                    role="menuitem"
                    data-testid="navbar.link.signin.link"
                >
                    {intl.formatMessage({ id: 'navbar.link.signin' })}
                </a>
            </li>
        </>
    );
};

SignIn.propTypes = {
    ...defaultAriaProps
};

export default SignIn;
